const desktopMenuMedia = window.matchMedia('(min-width: 990px)');

document.querySelectorAll('.header__inline-menu header-menu > details').forEach((details) => {
  let closeTimer;

  details.addEventListener('pointerenter', () => {
    if (!desktopMenuMedia.matches) return;
    window.clearTimeout(closeTimer);

    document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach((openDetails) => {
      if (openDetails !== details) openDetails.removeAttribute('open');
    });

    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  });

  details.addEventListener('pointerleave', () => {
    if (!desktopMenuMedia.matches) return;
    closeTimer = window.setTimeout(() => {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }, 140);
  });
});
